import { useState } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Services from "@/components/landing/Services";
import WhoWeServe from "@/components/landing/WhoWeServe";
import HowItWorks from "@/components/landing/HowItWorks";
import Pricing from "@/components/landing/Pricing";
import Portfolio from "@/components/landing/Portfolio";
import WhyGsoftware from "@/components/landing/WhyGsoftware";
import Team from "@/components/landing/Team";
import SubscribeCTA from "@/components/landing/SubscribeCTA";
import Footer from "@/components/landing/Footer";

function App() {
  const [selectedPlan, setSelectedPlan] = useState(null);

  const pickPlan = (plan) => {
    setSelectedPlan(plan);
    document.getElementById("subscribe")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="App">
      <Navbar />
      <main>
        <Hero onGetStarted={() => pickPlan("tier2")} />
        <Services />
        <WhoWeServe />
        <HowItWorks />
        <Pricing onSelectPlan={pickPlan} />
        <WhyGsoftware />
        <Portfolio />
        <Team />
        <SubscribeCTA selectedPlan={selectedPlan} onPlanChange={setSelectedPlan} />
      </main>
      <Footer />
      <Toaster theme="dark" position="top-center" />
    </div>
  );
}

export default App;
